import React, { useEffect, useContext, useState } from "react";
import { environmentVariables } from "../../config/env.config";
import CircularLoader from "../Components/CircularLoader/CircularLoader";
import successright from "../../Images/check.png";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const RedirectZinnaPage = () => {
  const { t } = useTranslation();
  const [amount, setAmount] = useState(null);
  const [paymethod, setPaymethod] = useState(null);
  const [isVerifying, setIsVerifying] = useState(true);
  const [paymentPopUp, setPaymentPopUp] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);

  const searchParams = new URLSearchParams(window.location.search);
  const orderId = searchParams.get("order_id");
  const curl = searchParams.get("curl");

  const handleRedirect = async () => {
    // Extract transaction token and company reference from URL params

    console.log("Order ID:", orderId);
    console.log("Curl:", curl);

    // setOrderID(transactionToken);


    if (orderId) {
      try {
        let config = {
          method: "get",
          url: `${environmentVariables?.apiUrl}api/v1/zinnapay/payment-status?order_id=${orderId}`,
        };

        axios
          .request(config)
          .then((responseData) => {
            console.log("response=>>>>", responseData?.data);
            setAmount(responseData?.data?.data?.status_data?.amount);
            setPaymethod(responseData?.data?.data?.status_data?.payment_method);
            if (responseData?.data?.success == true) {
                if(responseData?.data?.data?.status_data?.payment_status == "complete"){
                    setPaymentPopUp(true);
                    setPaymentSuccess(true);
                    setIsVerifying(false);
                    setTimeout(() => {
                        window.location.href = curl;
                    }, 3000);
                    return;
                }else{
                    toast.error("Error verifying payment order.");
                    setIsVerifying(false);
                    setPaymentPopUp(true);
                    setPaymentSuccess(false);
                    setTimeout(() => {
                        window.location.href = curl;
                    }, 3000);
                    setPaymentPopUp(true);
                }
             
            } else {
              toast.error("Error verifying payment order.");
              setIsVerifying(false);
              setPaymentPopUp(true);
              setPaymentSuccess(false);
              setTimeout(() => {
                window.location.href = curl;
              }, 3000);
              setPaymentPopUp(true);
            }
          })
          .catch((error) => {
            setIsVerifying(false);
            setPaymentPopUp(false);
            setPaymentSuccess(false);
            setTimeout(() => {
              window.location.href = curl;
            }, 3000);
            console.error("Error verifying payment order:", error);
          });
      } catch (error) {
        setIsVerifying(false);
        setPaymentPopUp(false);
        setPaymentSuccess(false);
        setTimeout(() => {
          window.location.href = curl;
        }, 3000);
        console.error("Error verifying payment order:", error);
      }
    } else {
      setIsVerifying(false);
      setPaymentPopUp(false);
      setPaymentSuccess(false);
      setTimeout(() => {
        window.location.href = curl;
      }, 3000);
      toast.error("TransactionToken or CompanyRef not found in URL.");
    }
  };
  useEffect(() => {
    handleRedirect();
  }, []);
  console.log("paymentSuccess",paymentSuccess)
  return (
    <>
      {isVerifying ? (
        <div className="loader-container-dpo">
          <CircularLoader />
          <h4>{t("Processing_order")}</h4>
          <p>{t("Thank_for_order")}</p>
        </div>
      ) : (
        <form>
          {paymentSuccess ? (
            <div className="loader-container-dpo">
              <h4>{t("Payment_verified")}</h4>
            </div>
          ) : (
            <div className="loader-container-dpo">
              <h4>{t("Something_went_wrong")}</h4>
            </div>
          )}
        </form>
      )}
      {paymentPopUp && (
        <div className="popup-outer">
          <div className="popup-overlay"></div>
          <div className="popup-inner">
            <div className="fs-1 payment_heaader">
              {paymentSuccess ? (
                <span className="text-success">{"Payment Successful"}</span>
              ) : (
                <span className="text-danger">{"Payment Failed"}</span>
              )}
            </div>
            {paymentSuccess ? (
              <img loading="lazy" src={successright} className="" />
            ) : (
              ""
            )}
            <div className="inner-box mt-4">
              <h1 className="name">{t("Payment_details")}</h1>
              <div className="orderbox">
                <ul className="list-group mb-3">
                  <li className="list-group-item d-flex justify-content-between">
                    <span>{t("Receiver")}</span>
                    <strong>{t("Businessbay")}</strong>
                  </li>
                  <li className="list-group-item d-flex justify-content-between">
                    <span>{t("Payment_method_type")}</span>
                    <strong>{paymethod}</strong>
                  </li>

                  <li className="list-group-item d-flex justify-content-between">
                    <span> {t("Amount_paid")}</span>
                    <strong>
                      {amount}
                      {" AED"}
                    </strong>
                  </li>

                  <li className="list-group-item d-flex justify-content-between">
                    <span>{t("Transaction_id")}</span>
                    <strong>{orderId}</strong>
                  </li>
                </ul>
                {/* <button
                type="submit"
                className="btn try_theme_btn mx-auto d-block submitclose"
                onClick={handleClosePopUp}
              >
                {t("Close")}
              </button> */}
              </div>
              <div className="order-box">{/* Your payment details here */}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RedirectZinnaPage;
